import { Flex, Box, Paragraph, Heading, Image } from 'theme-ui';

import { BlogNav } from '../../blog/BlogNav';

import { themed } from './Header.theme';

export const Header = themed(({ title, author, date, image, theme }) => {
  return (
    <Box data-comp={Header.displayName}>
      <Flex variant="flex.column.center.center">
        <Box sx={theme.date}>
          <Paragraph>
            {author} | {date}
          </Paragraph>
        </Box>
      </Flex>
      {title && (
        <Heading as="h1" sx={theme.title}>
          {title}
        </Heading>
      )}
      {/* <BlogNav articlePage /> */}
      {image && (
        <Image alt="Blog article image" src={image} sx={theme.articleHero} />
      )}
    </Box>
  );
});

Header.displayName = 'Header';
